'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FullScreenModal = require('../../../components/modal/FullScreenModal');

var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var ChangePasswordSuccessModal = function ChangePasswordSuccessModal(_ref) {
    var navigateToLogin = _ref.navigateToLogin;
    return _react2.default.createElement(
        _FullScreenModal2.default,
        null,
        _react2.default.createElement(
            'div',
            { className: 'logo' },
            _react2.default.createElement(_Icon2.default, { name: 'milanote-logo-large' })
        ),
        _react2.default.createElement(
            'div',
            { className: 'heading' },
            _react2.default.createElement(
                'h2',
                { className: 'with-icon' },
                _react2.default.createElement(_Icon2.default, { name: 'green-tick' }),
                _react2.default.createElement(
                    'span',
                    null,
                    'Password changed'
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
                'p',
                null,
                'Your password has been changed.'
            ),
            _react2.default.createElement(
                'p',
                null,
                'You can log in with the new password by following the link below.'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'section secondary' },
            _react2.default.createElement(
                'div',
                { className: 'return-to-login' },
                'Go back to the \xA0',
                _react2.default.createElement(
                    'a',
                    { href: '/login', onClick: navigateToLogin },
                    'Log in screen'
                )
            )
        )
    );
};

ChangePasswordSuccessModal.propTypes = {
    navigateToLogin: _propTypes2.default.func.isRequired
};

exports.default = ChangePasswordSuccessModal;


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/changePassword/ChangePasswordSuccessModal.js
// module id = 1674
// module chunks = 0